import { z } from "zod";
import { zStringId, zTimestamps } from "../../utils";

export const zLocation = z.object({
  addressLine1: z.string(),
  addressLine2: z.string().optional(),
  zip: z.string().optional(),
  city: z.string(),
  cityCode: z.string().optional(),
  country: z.string(),
  countryCode: z.string(),
});

export const zLocationSnippet = z.object({
  city: z.string(),
  country: z.string(),
});

// TODO
export const zUser = z.object({
  _id: zStringId(),
  firstName: z.string(),
  lastName: z.string().optional(),
  companyName: z.string().optional(),
  username: z.string().optional(),
  phone: z.string().optional(),
  streetAddress: z.string().optional(),
  city: z.string().optional(),
  zipCode: z.string().optional(),
  country: z.string().optional(),
  countryCode: z.string().optional(),
  gender: z.enum(["0", "1", "2"]),
  email: z.string(),
  password: z.string(),
  profileImage: z.string(),

  roleId: zStringId(),
  roleDoc: z.any(),

  ...zTimestamps(),
});

export type User = z.infer<typeof zUser>;
